module.exports = __webpack_public_path__ + "img/icon-restaurant-mini-addtable.4d8a768b.png";